import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationSubscriptionsApplePaySubscription = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
